export default "__VITE_ASSET__3229e734__"